module.exports = __webpack_public_path__ + "static/media/KaTeX_SansSerif-Italic.99ad93a4.woff2";